import { FC } from 'react'
import { useSelector } from 'react-redux'
import { Navigate, Outlet, useParams } from 'react-router-dom'
import { PrivateRoutes } from '../constants/routes'
import { IConfigSeller } from '../models/configSeller'

interface IOwnProps{
  sellerSlug?: string | string[]
  // Alternativa al slug: permite el acceso segun el FOLDER_APP del seller cargado.
  folderApp?: string | string[]
}

const SlugRouterGuard: FC<IOwnProps> = ({ sellerSlug, folderApp }) => {
  const { slug } = useParams<{ slug: string }>()
  const configSeller = useSelector((store: { config: IConfigSeller }) => store.config)
  const PrivateValidationFragment = <Outlet />

  const allowedSlugs = (sellerSlug !== undefined ? (Array.isArray(sellerSlug) ? sellerSlug : [sellerSlug]) : []).map(s => s.toUpperCase())
  const allowedFolders = folderApp ? (Array.isArray(folderApp) ? folderApp : [folderApp]) : []

  const isAllowed = (slug !== undefined && allowedSlugs.includes(slug.toUpperCase())) ||
    allowedFolders.includes(String(configSeller.config?.s3?.FOLDER_APP))

  return isAllowed ? PrivateValidationFragment : <Navigate replace to={PrivateRoutes.HOME.replace(':slug', String(slug))} />
}

export default SlugRouterGuard
